export function converterPeso(valor: number) {
	if (valor >= 1) {
		return `${valor.toFixed(2)}kg`
	}
	return `${(valor * 1000).toFixed(2)}g`
}
